"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
let fsModule;
exports.default = () => {
    if (typeof module === 'object' && typeof module.exports === 'object') {
        fsModule = fsModule ? fsModule : require('fs');
        return fsModule;
    }
    throw new Error('File system is not available');
};
//# sourceMappingURL=node.js.map